module.exports = __webpack_public_path__ + "25ea0504b587f3aa475f527745d974ac.ttf";